/**
 * Revoked-device signalling (decision-log D81, closes O113). Manifest and heartbeat
 * endpoints return RFC 9457 problem+json with this `type`; every other 4xx keeps the
 * cached loop (technical-design §11.7). Event upload is not checked here — a retired
 * device may still ack in-flight plays for its screen.
 */

export const DEVICE_TOKEN_REVOKED_PROBLEM_TYPE = 'urn:digitalwave:errors:device-token-revoked';

/** @deprecated Use {@link DEVICE_TOKEN_REVOKED_PROBLEM_TYPE}. */
export const REVOKED_PROBLEM_TYPE_SUFFIX = 'device-token-revoked';

export function isDeviceTokenRevokedResponse(status: number, body: string): boolean {
  if (status !== 401 && status !== 403) return false;
  try {
    const parsed = JSON.parse(body) as { type?: unknown };
    if (typeof parsed.type === 'string') {
      return parsed.type === DEVICE_TOKEN_REVOKED_PROBLEM_TYPE;
    }
  } catch {
    // Non-JSON bodies are unexpected but must not miss a revocation signal.
  }
  return body.includes(DEVICE_TOKEN_REVOKED_PROBLEM_TYPE);
}
